<script>
    import { onMount, onDestroy } from 'svelte';
  
    export let selectedItem;
    export let dispatch;
  
    let destinationMap;
    let destinationMarker;
    let targetRef = selectedItem?.target_ref || '';
    let isEditing = false;
  
    function saveLocation(lat, lng, isDelivery = false) {
      const geo_ref = `${lat},${lng}`;
      const payload = {
        id: selectedItem.id,
        [isDelivery ? 'geo_delivery_ref' : 'geo_target_ref']: geo_ref,
        isDelivery,
      };
      console.log("Dispatching updateLocation:", payload);
      dispatch('updateLocation', payload);
    }

    function saveTargetRef() {
      const payload = {
        id: selectedItem.id,
        target_ref: targetRef
      };
      console.log("Dispatching updateTargetRef:", payload);
      dispatch('updateDelivery', payload);
      isEditing = false;
    }

    function toggleEdit() {
      isEditing = !isEditing;
      if (!isEditing) {
        targetRef = selectedItem?.target_ref || '';
      }
    }
  
    // Initialize destination map
    function initializeDestinationMap() {
        if (!selectedItem) return;

        let targetRef = selectedItem.geo_target_ref;
        if (targetRef) {
        const [lat, lng] = targetRef.split(',').map(parseFloat);
        initMap('destination-map-canvas', lat, lng, false);
        } else {
        initMap('destination-map-canvas', 14.603032776408446, -90.53445609626046, false);
        }
    }
    function initMap(mapId, lat, lng, isDelivery = false) {
      const google = window.google;
      if (!google) {
        console.error('Google Maps not loaded');
        return;
      }
  
      const mapElement = document.getElementById(mapId);
      if (!mapElement) {
        console.error('Map canvas element not found:', mapId);
        return;
      }
  
      const myLatlng = new google.maps.LatLng(lat, lng);
      const mapOptions = {
        zoom: 16,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          // Map styles...
        ],
      };
  
      const mapInstance = new google.maps.Map(mapElement, mapOptions);
      const markerInstance = new google.maps.Marker({
        position: myLatlng,
        map: mapInstance,
        animation: google.maps.Animation.DROP,
        title: isDelivery ? "Ubicación de entrega" : "Ubicación destino",
        draggable: true,
      });
  
      if (!isDelivery) {
        destinationMap = mapInstance;
        destinationMarker = markerInstance;
      }
  
      markerInstance.addListener('dragend', () => {
        const position = markerInstance.getPosition();
        console.log("Marker dragged:", { lat: position.lat(), lng: position.lng(), isDelivery });
        saveLocation(position.lat(), position.lng(), isDelivery);
      });
  
      mapInstance.addListener('click', (event) => {
        const newPosition = event.latLng;
        console.log("Map clicked:", { lat: newPosition.lat(), lng: newPosition.lng(), isDelivery });
        markerInstance.setPosition(newPosition);
        saveLocation(newPosition.lat(), newPosition.lng(), isDelivery);
      });
    }
  
    onMount(() => {
      initializeDestinationMap();
    });
  
    onDestroy(() => {
      if (destinationMarker) destinationMarker.setMap(null);
      if (destinationMap) google.maps.event.clearInstanceListeners(destinationMap);
    });
  </script>
  
  <div class="space-y-4">
    <div>
      <div class="mt-2 text-sm text-blueGray-600">
        Para actualizar la ubicación destino: 
        • Arrastre el marcador a la nueva ubicación, o
        • Haga clic en el mapa para colocar el marcador
      </div>
      <h2 class="text-lg font-bold text-blueGray-700 mb-4">Ubicación destino del pedido</h2>
      <div class="mb-4">
        <label for="target-ref" class="block text-sm font-medium text-gray-700">Referencia:</label>
        <div class="mt-1 flex rounded-md shadow-sm">
          {#if isEditing}
            <input
              type="text"
              id="target-ref"
              bind:value={targetRef}
              class="flex-1 min-w-0 block w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Ingrese la referencia del destino"
            />
            <div class="flex items-center ml-3">
              <button
                class="bg-blueGray-600 text-white active:bg-blueGray-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                on:click={toggleEdit}
              >
                Cancelar
              </button>
              <button
                class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                on:click={saveTargetRef}
              >
                Guardar Cambios
              </button>
            </div>
          {:else}
            <span class="flex-1 min-w-0 block w-full px-3 py-2 rounded-md bg-gray-50 text-gray-900 sm:text-sm">
              {targetRef || 'Sin referencia'}
            </span>
            <button
              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button"
              on:click={toggleEdit}
            >
              Editar
            </button>
          {/if}
        </div>
      </div>
      <div
        id="destination-map-canvas"
        class="relative w-full rounded h-96 mt-4"
        style="min-height: 400px;"
      ></div>
    </div>
  </div>